module.exports = __webpack_public_path__ + "img/avatar_1@2x.b6c2110d.png";